import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

// COMPONENTS
import SearchCardManager from '@/components/Cards/SearchCardManager';

// HELP
import { Container } from '../styles';

const ContentCrewSection = ({ className, data, analyticsLocation, ...props }) => {
  const [t] = useTranslation();

  return (
    <Container
      {...props}
      className={clsx('section-manager', 'section-manager-content-crew', className)}
    >
      <Typography className="section-manager__title" variant="h3">
        {t('common.actorsDirectors')}
      </Typography>
      <Grid container spacing={2}>
        {data.data.map((item, idx) => (
          <Grid item xs={12} key={idx}>
            <SearchCardManager
              type={data.type}
              data={item}
              actions={[]}
              analyticsLocation={analyticsLocation}
            />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

ContentCrewSection.defaultProps = {
  className: '',
  analyticsLocation: '',
};

ContentCrewSection.propTypes = {
  data: PropTypes.object.isRequired,
  className: PropTypes.string,
  analyticsLocation: PropTypes.string,
};

export default React.memo(ContentCrewSection);
